import React, {} from 'react';
import './App.css';
import ConfigApp from "./views/config/ConfigApp";

function App() {


  return (
      <ConfigApp/>
  );
}

export default App;
